export const PAGE_SIZE = 25
export const ENTITY_PREFIX_PRODUCTZONE = 'PRODUCTZONE#'
export const ENTITY_PREFIX_PRICINGZONE = 'PRICINGZONE#'
export const ENTITY_PREFIX_LOCATION = 'LOCATION#'
export const ENTITY_PREFIX_ZONE = 'ZONE#'
export const ENTITY_PREFIX_INVENTORYZONE = 'INVENTORYZONE#'
export const ENTITY_PREFIX_PRODUCT = 'PRODUCT#'
export const ENTITY_PREFIX_SNAPSHOT = 'OVERRIDE#'
